import RFB from './novnc/core/rfb'
import * as qs from 'query-string'
import { sleep } from './utils'

export async function makeVNCConnection(isAdmin: boolean, username: string, password: string, userId = ''): Promise<boolean> {
	try {
		const query = qs.parse(window.location.search)
		if (userId) {
			if (!query.accessToken) {
				return true
			}
			const token = query.accessToken as string
			const userIdSub = atob(token.split('.')[1])
			const userIdJson = JSON.parse(userIdSub)
			if (userIdJson.sub && userIdJson.sub !== userId) {
				return true
			}
		}

		const elm = document.getElementById('screen')
		if (elm) {
			elm.innerHTML = ''
		}
		const rfb = new RFB(elm, `wss://editor.lynxcloud.app/novnc/${username}/websockify`, {
			credentials: { password }
		})
		rfb.scaleViewport = true
		rfb.clipViewport = true
		rfb.resizeSession = false
		rfb.viewOnly = !isAdmin
		rfb.showDotCursor = true

		rfb.addEventListener('disconnect', async () => {
			await sleep(3000)
			await makeVNCConnection(isAdmin, username, password, userId)
		})

		return new Promise((resolve) => {
			rfb.addEventListener('connect', async () => {
				resolve(true)
			})
		})
	} catch (err) {
		console.error(err)
		return false
	}
}
